import { render, staticRenderFns } from "./MailSubscriptionList.vue?vue&type=template&id=6e1c461c&"
import script from "./MailSubscriptionList.vue?vue&type=script&lang=js&"
export * from "./MailSubscriptionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports